<template>
    <div class="serial-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Pembayaran',
                    to: { path: '/produk' },
                    exact: true,
                },
                {
                    text: 'Jadwal Kelas',
                    to: { path: '/jadwal-kelas' },
                    exact: true,
                },
                {
                    text: !$route.query.id
                        ? 'Tambah Jadwal Kelas'
                        : 'Ubah Jadwal Kelas',
                },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 v-show="tab == 1" class="header-text font-weight-bold">
            {{ !$route.query.id ? "Tambah Jadwal Kelas" : "Ubah Jadwal Kelas" }}
        </h3>

        <h3
            v-if="$route.query.id"
            v-show="tab == 2"
            class="header-text font-weight-bold"
        >
            Member Kelas
        </h3>

        <v-layout class="pt-0 px-0 pb-3 mb" v-if="$route.query.id">
            <v-btn
                class="mr-2"
                :class="tab == 2 ? 'darkFade--text' : 'white--text'"
                :color="tab == 2 ? 'white' : 'blew'"
                elevation="0"
                @click="tab = 1"
                >Detail</v-btn
            >
            <v-btn
                :class="tab == 2 ? 'white--text' : 'darkFade--text'"
                :color="tab == 2 ? 'blew' : 'white'"
                class="mr-2"
                elevation="0"
                @click="tab = 2"
                >Members</v-btn
            >
        </v-layout>

        <v-card v-show="tab == 1" plain class="pa-4">
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Deskripsi *
                    </v-list-item-title>
                    <v-textarea
                        placeholder="Deskripsi paket"
                        v-model="form.description"
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="px-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Kuota *
                    </v-list-item-title>
                    <v-text-field
                        type="number"
                        v-model="form.quota"
                        outlined
                        hide-details
                    />
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="px-0 py-4">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Threshold *
                    </v-list-item-title>
                    <v-text-field
                        type="number"
                        v-model="form.threshold"
                        outlined
                        hide-details
                    />
                </v-list-item-content>
            </v-list-item>
            <v-list-item class="px-0 py-2">
                <v-row>
                    <v-col cols="6">
                        <v-list-item two-line class="py-0 px-1">
                            <v-list-item-content>
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Waktu Mulai *
                                </v-list-item-title>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-menu
                                                ref="menu"
                                                v-model="form.start_time.option"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="slide-y-reverse-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-text-field
                                                        v-model="
                                                            form.start_time
                                                                .value
                                                        "
                                                        outlined
                                                        placeholder="Jam : Menit"
                                                        append-icon="mdi-clock-time-four-outline"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-time-picker
                                                    v-if="
                                                        form.start_time.option
                                                    "
                                                    v-model="
                                                        form.start_time.value
                                                    "
                                                    @change="
                                                        form.start_time.option = false
                                                    "
                                                    format="24hr"
                                                ></v-time-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                    <v-col cols="6">
                        <v-list-item two-line class="py-0 px-1">
                            <v-list-item-content>
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Waktu Berakhir *
                                </v-list-item-title>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-menu
                                                ref="menu"
                                                v-model="form.end_time.option"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="slide-y-reverse-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-text-field
                                                        v-model="
                                                            form.end_time.value
                                                        "
                                                        outlined
                                                        placeholder="Jam : Menit"
                                                        append-icon="mdi-clock-time-four-outline"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-time-picker
                                                    v-if="form.end_time.option"
                                                    v-model="
                                                        form.end_time.value
                                                    "
                                                    @change="
                                                        form.end_time.option = false
                                                    "
                                                    format="24hr"
                                                ></v-time-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                </v-row>
            </v-list-item>
            <v-divider></v-divider>
            <v-card-actions class="py-2">
                <v-spacer></v-spacer>

                <v-btn text @click="$router.push({ path: '/jadwal-kelas' })">
                    Batal
                </v-btn>

                <v-btn color="primary" @click="onSubmit"> Simpan </v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-if="$route.query.id" v-show="tab == 2" style="border">
            <v-card-title>
                Daftar Partisipan ({{ countStudents }})
                <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-container fluid class="pa-4">
                <v-row no-gutters>
                    <v-col>
                        <v-text-field
                            v-model="params.search"
                            outlined
                            height="36px"
                            hide-details
                            small
                            dense
                            class="search_box"
                            @keyup.enter="getListMembers()"
                            placeholder="Ketik kata kunci dan tekan enter"
                        >
                            <template slot="prepend-inner">
                                <svg
                                    style="margin-top: 10px !important"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M8.33342 15.0001C9.81256 14.9998 11.2491 14.5046 12.4142 13.5934L16.0776 17.2567L17.2559 16.0784L13.5926 12.4151C14.5042 11.2498 14.9997 9.81295 15.0001 8.33341C15.0001 4.65758 12.0092 1.66675 8.33342 1.66675C4.65758 1.66675 1.66675 4.65758 1.66675 8.33341C1.66675 12.0092 4.65758 15.0001 8.33342 15.0001ZM8.33342 3.33341C11.0909 3.33341 13.3334 5.57591 13.3334 8.33341C13.3334 11.0909 11.0909 13.3334 8.33342 13.3334C5.57591 13.3334 3.33341 11.0909 3.33341 8.33341C3.33341 5.57591 5.57591 3.33341 8.33342 3.33341Z"
                                        fill="#073554"
                                    />
                                    <path
                                        d="M9.50994 7.15507C9.82577 7.47174 9.99994 7.89007 9.99994 8.33341H11.6666C11.6673 7.89543 11.5813 7.46165 11.4133 7.05714C11.2454 6.65264 10.999 6.28543 10.6883 5.97674C9.4266 4.71674 7.2391 4.71674 5.97827 5.97674L7.15494 7.15674C7.78827 6.52507 8.87994 6.52674 9.50994 7.15507Z"
                                        fill="#073554"
                                    />
                                </svg>
                            </template>
                        </v-text-field>
                    </v-col> </v-row
            ></v-container>
            <v-card-text class="pt-0">
                <v-card
                    class="my-2"
                    outlined
                    v-for="(student, index) in students"
                    v-bind:key="index"
                >
                    <v-list class="px-2 py-0 text-subtitle-2">
                        <template>
                            <v-list-item two-line>
                                <v-list-item-content
                                    class="ma-0 align-self-start"
                                    style="max-width: 20%"
                                >
                                    <v-list-item-subtitle
                                        class="font-weight-bold"
                                    >
                                        Nama
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle
                                        style="
                                            text-overflow: unset;
                                            white-space: unset;
                                        "
                                    >
                                        {{ student.name }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-content
                                    class="mx-2 my-0 align-self-start"
                                >
                                    <v-list-item-subtitle
                                        class="font-weight-bold"
                                    >
                                        Email
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle
                                        style="
                                            text-overflow: unset;
                                            white-space: unset;
                                        "
                                    >
                                        {{ `${student.email}` }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list>
                </v-card>
            </v-card-text>
            <v-card-actions class="px-6 pb-4 pt-0">
                <span class="gray3--text">
                    Menampilkan {{ students.length * pageNumber }} dari -
                </span>
                <v-spacer></v-spacer>
                <v-btn
                    depressed
                    class="pa-0"
                    :disabled="pageNumber == 1"
                    @click="--pageNumber"
                    min-width="32px"
                    height="32px"
                >
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn
                    class="pa-0 mx-2"
                    depressed
                    dark
                    color="blew"
                    min-width="32px"
                    height="32px"
                >
                    {{ pageNumber }}
                </v-btn>
                <v-btn
                    depressed
                    class="pa-0 ma-0"
                    min-width="32px"
                    height="32px"
                    :disabled="students.length < 25"
                    @click="++pageNumber"
                >
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import Autocomplete from "@/modules/global/components/plugins/Autocomplete";
import SalesService from "@/modules/global/services/sales.js";
import Spinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "ModulPembelajaranForm",

    components: {
        "app-autocomplete": Autocomplete,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            url: null,
            tab: 1,
            form: {
                description: "",
                quota: null,
                start_time: {
                    option: false,
                    value: null,
                },
                end_time: {
                    option: false,
                    value: null,
                },
                threshold: null,
                is_active: 1,
            },
            start_time: null,
            end_time: null,
            errors: [],
            isLoading: false,
            params: {
                search: "",
                page: 1,
                maxpage: 1,
                size: 10,
            },
            pageNumber: 1,
            students: [],
            countStudents: 0,
        };
    },

    watch: {
        pageNumber() {
            if (this.pageNumber > 0) {
                if (this.pageNumber <= this.params.maxpage) {
                    this.params.page = this.pageNumber;
                    this.getListMembers();
                } else {
                    this.pageNumber = this.params.page;
                    alert(
                        "Data Hanya sampai " + this.params.maxpage + " halaman",
                    );
                }
            } else if (this.pageNumber < 1) this.pageNumber = 1;
        },
    },

    methods: {
        validateForm: function () {
            var err = false;
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            if (
                !this.form.description ||
                this.form.description == "" ||
                this.form.description == " " ||
                this.form.description.trim() == ""
            ) {
                this.$store.commit("showAlert", {
                    message: `Deskripsi wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.form.quota || this.form.quota == "") {
                this.$store.commit("showAlert", {
                    message: `Kuota wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.form.threshold || this.form.threshold == "") {
                this.$store.commit("showAlert", {
                    message: `Threshold wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (
                !this.form.start_time.value ||
                this.form.start_time.value == ""
            ) {
                this.$store.commit("showAlert", {
                    message: `Start Time wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (
                !this.form.end_time.value ||
                this.form.end_time.value == ""
            ) {
                this.$store.commit("showAlert", {
                    message: `End Time wajib diisi!`,
                    type: "error",
                });
                err = true;
            }
            return !err;
        },

        findmapel(data) {
            const found = this.mapelList.find((mapel) => mapel.nama == data);
            return found;
        },

        onSubmit() {
            if (this.$route.query.id) {
                this.updateData(this.$route.query.id);
            } else {
                this.saveData();
            }
        },

        updateData(id) {
            var context = this;
            var data = this.form;

            if (this.validateForm()) {
                data.start_time = data.start_time.value;
                data.end_time = data.end_time.value;
                context.isLoading = true;

                SalesService.updateJadwalKelas(id, data, function (result) {
                    if (result.success) {
                        context.$store.commit("showAlert", {
                            message: `Data berhasil disimpan!`,
                            type: "success",
                        });
                        context.isLoading = false;
                        context.$router.go(-1);
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Terjadi Kesalahan!`,
                            submessage: `Data gagal disimpan!`,
                            type: "error",
                        });
                        context.isLoading = false;
                    }
                    context.isLoading = false;
                });
            } else {
                this.isLoading = false;
                $(window).scrollTop(0);
            }
        },

        saveData: function () {
            var context = this;
            var data = this.form;

            if (this.validateForm()) {
                data.start_time = data.start_time.value;
                data.end_time = data.end_time.value;
                context.isLoading = true;
                SalesService.createJadwalKelas(data, function (result) {
                    if (result.success) {
                        context.$store.commit("showAlert", {
                            message: `Data berhasil disimpan!`,
                            type: "success",
                        });
                        context.isLoading = false;
                        context.$router.go(-1);
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Terjadi Kesalahan!`,
                            submessage: `Data gagal disimpan!`,
                            type: "error",
                        });
                        context.isLoading = false;
                    }
                    context.isLoading = false;
                });
            } else {
                this.isLoading = false;
                $(window).scrollTop(0);
            }
        },

        getDetail(id) {
            const context = this;
            SalesService.getDetailJadwal(id, function (result) {
                if (result.success) {
                    context.form = result.data;
                    context.form.start_time = {
                        value: context.form.start_time,
                        option: false,
                    };
                    context.form.end_time = {
                        value: context.form.end_time,
                        option: false,
                    };
                    context.isLoading = false;
                } else {
                    context.isLoading = false;
                }
                context.isLoading = false;
            });
        },

        getListMembers() {
            const context = this;
            context.isLoading = true;
            context.students = [];
            SalesService.getMembersKelas(
                context.$route.query.id,
                context.params,
                function (result) {
                    if (result.success) {
                        context.students =
                            result.data.list_group_member_details;
                        context.params.maxpage = result.data.max_page;
                        context.countStudents = result.data.total_member;
                    } else {
                        alert("Gagal mengambil data Members kelas");
                    }
                    context.isLoading = false;
                },
            );
        },
    },

    mounted: function () {
        var context = this;

        ClockpickerPlugin.init("#start_time", function (value) {
            context.form.start_time.value = value;
        });

        ClockpickerPlugin.init("#end_time", function (value) {
            context.form.end_time.value = value;
        });

        if (this.$route.query.id) {
            this.getDetail(this.$route.query.id);
            this.getListMembers();
        }
    },
};
</script>

<style scoped>
#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

#preview img {
    max-width: 100%;
    max-height: 200px;
}
</style>



// WEBPACK FOOTER //
// JadwalKelasForm.vue?dcb57d80